"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SystemPayoutHold;
(function (SystemPayoutHold) {
    SystemPayoutHold["PAYMENT_METHOD_MISSING"] = "PAYMENT_METHOD_MISSING";
})(SystemPayoutHold = exports.SystemPayoutHold || (exports.SystemPayoutHold = {}));
